import React from 'react';

export const downloadDetailPageStyles = {
  page: {
    minHeight: '100%',
    background: '#f8fafc',
    padding: '18px 18px 30px',
    boxSizing: 'border-box',
  } as React.CSSProperties,
  shell: {
    width: '100%',
    maxWidth: 560,
    margin: '0 auto',
  } as React.CSSProperties,
  navRow: {
    minHeight: 44,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginBottom: 12,
  } as React.CSSProperties,
  backButton: {
    minWidth: 44,
    minHeight: 44,
    borderRadius: 16,
    border: '1px solid #e5e7eb',
    background: '#ffffff',
    color: '#111827',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  } as React.CSSProperties,
  localeSwitcher: {
    minWidth: 112,
    minHeight: 38,
    padding: '0 12px',
    fontSize: 12,
    boxShadow: '0 8px 18px rgba(15, 23, 42, 0.06)',
  } as React.CSSProperties,
  eyebrow: {
    fontSize: 12,
    lineHeight: 1.3,
    color: '#b45309',
    fontWeight: 800,
    textTransform: 'uppercase',
  } as React.CSSProperties,
  title: {
    margin: '8px 0 8px',
    fontSize: 30,
    lineHeight: 1.15,
    fontWeight: 850,
    color: '#111827',
  } as React.CSSProperties,
  intro: {
    marginBottom: 18,
    fontSize: 15,
    lineHeight: 1.65,
    color: '#4b5563',
  } as React.CSSProperties,
  section: {
    borderRadius: 22,
    background: '#ffffff',
    border: '1px solid rgba(15, 23, 42, 0.06)',
    padding: '16px 16px',
    marginBottom: 12,
    boxShadow: '0 10px 22px rgba(15, 23, 42, 0.05)',
  } as React.CSSProperties,
  sectionHeader: {
    display: 'flex',
    gap: 10,
    alignItems: 'flex-start',
    marginBottom: 10,
  } as React.CSSProperties,
  stepIndex: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    background: '#111827',
    color: '#ffffff',
    fontSize: 13,
    fontWeight: 800,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  } as React.CSSProperties,
  sectionTitle: {
    fontSize: 17,
    lineHeight: 1.35,
    fontWeight: 800,
    color: '#111827',
  } as React.CSSProperties,
  sectionBody: {
    paddingLeft: 38,
    fontSize: 14,
    lineHeight: 1.65,
    color: '#4b5563',
  } as React.CSSProperties,
  list: {
    margin: '8px 0 0',
    paddingLeft: 18,
  } as React.CSSProperties,
  listItem: {
    marginBottom: 6,
  } as React.CSSProperties,
  cta: {
    marginTop: 20,
    '--border-radius': '18px',
    height: 50,
    fontSize: 15,
    fontWeight: 800,
  } as React.CSSProperties,
};
